/**
 * Centralized bulk action labels and constants for consistent UI across all entities
 */

export const BULK_ACTION_LABELS = {
  // Quick Actions
  ACTIVATE: "Activate",
  DEACTIVATE: "Deactivate",
  MARK_COMPLETE: "Mark Complete",

  // Status & Type
  UPDATE_STATUS: "Update Status",
  UPDATE_TYPE: "Update Type",
  UPDATE_PRIORITY: "Update Priority",

  // Tags
  ADD_TAGS: "Add Tags",

  // Assignment
  ASSIGN_TO_USER: "Assign to User",

  // Export
  EXPORT: "Export",
  EXPORT_EMAILS: "Export Emails",

  // Delete
  DELETE: "Delete",
} as const;

export const BULK_ACTION_IDS = {
  // Quick Actions
  ACTIVATE: "activate",
  DEACTIVATE: "deactivate",
  COMPLETE: "complete",

  // Status & Type
  UPDATE_STATUS: "update_status",
  UPDATE_TYPE: "update_type",
  UPDATE_PRIORITY: "update_priority",

  // Tags
  ADD_TAGS: "add_tags",

  // Assignment
  ASSIGN: "assign",

  // Export
  EXPORT: "export",
  EXPORT_EMAILS: "export_emails",

  // Delete
  DELETE: "delete",
} as const;

export const BULK_ACTION_GROUPS = {
  QUICK: "quick",
  STATUS: "status",
  TAGS: "tags",
  ASSIGN: "assign",
  PRIORITY: "priority",
  SYSTEM: "system",
} as const;

export const BULK_ACTION_GROUP_LABELS = {
  QUICK: "Quick Actions",
  STATUS: "Status & Type",
  TAGS: "Tags",
  ASSIGN: "Assignment",
  PRIORITY: "Priority",
  SYSTEM: "System",
} as const;
